import { apiFetch } from "./apiFetch";

export async function listBookingsForUser() {
  const res = await apiFetch("/api/bookings", { method: "GET" });
  return Array.isArray(res?.items) ? res.items : [];
}

// сейчас у тебя бекенд по /api/bookings сам отдаёт “мои”,
// поэтому для tutor/student можно одинаково
export async function listBookingsForTutorUser() {
  const res = await apiFetch("/api/bookings", { method: "GET" });
  return Array.isArray(res?.items) ? res.items : [];
}

export async function createBooking(payload) {
  const body = {
    tutorId: payload.tutorId,
    tutorName: payload.tutorName,
    subject: payload.subject || "General",
    mode: payload.mode || "online",
    startISO: payload.startISO,
    message: payload.message || "",
    rate: payload.rate ?? null,
  };

  return apiFetch("/api/bookings", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function updateBooking(id, patch) {
  return apiFetch(`/api/bookings/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export async function cancelBooking(id, who) {
  const status = who === "student" ? "cancelled" : "declined";
  return updateBooking(id, { status });
}

export async function rescheduleBooking(id, newISO) {
  return updateBooking(id, { startISO: newISO });
}

export async function getBooking(id) {
  return apiFetch(`/api/bookings/${encodeURIComponent(id)}`, { method: "GET" });
}

export async function markBookingPaid(id) {
  return updateBooking(id, { paymentStatus: "paid" });
}
